
import React from 'react';

const FAQPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h1 className="text-4xl font-serif font-bold text-stone-900">Sıkça Sorulan Sorular</h1>
        <div className="space-y-8 font-medium">
          <div className="p-8 bg-white rounded-3xl border border-stone-100 shadow-sm space-y-2">
            <h3 className="font-bold text-stone-900">Mumlarınızda ne tür wax kullanıyorsunuz?</h3>
            <p className="text-sm text-stone-500">Sadece %100 doğal soya wax ve balmumu kullanıyoruz. Parafin içermez.</p>
          </div>
          <div className="p-8 bg-white rounded-3xl border border-stone-100 shadow-sm space-y-2">
            <h3 className="font-bold text-stone-900">Özel tasarım biblo yaptırabilir miyiz?</h3>
            <p className="text-sm text-stone-500">Toplu kurumsal siparişlerinizde özel renk ve form çalışmaları yapabiliyoruz. Detaylar için bizimle iletişime geçin.</p>
          </div>
          <div className="p-8 bg-white rounded-3xl border border-stone-100 shadow-sm space-y-2">
            <h3 className="font-bold text-stone-900">Mumların yanış süresi ne kadardır?</h3>
            <p className="text-sm text-stone-500">Ürün boyutuna göre değişmekle birlikte, standart mumlarımız 25-40 saat arası yanış süresine sahiptir.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
